// extracted by mini-css-extract-plugin
export default {"vote_card":"styles_vote_card__CgJxI","input_label":"styles_input_label__rjPii","button":"styles_button__tBBSK"};